$dependencyManager.addDependenciesCallback(['gsap', 'scrollTrigger'], () => {
  function initializeHotspotsAndAccordion() {
    gsap.registerPlugin(ScrollTrigger);

    const hotspotData = [
      { label: '', position: { x: '39%', y: '11%' } },
      { label: '', position: { x: '21%', y: '27%' } },
      { label: '', position: { x: '40%', y: '51%' } },
      { label: '', position: { x: '12%', y: '51%' } },
      { label: '', position: { x: '63%', y: '73%' } },
      { label: '', position: { x: '90%', y: '54%' } },
    ];

    const accordionContainer = jQuery('.moreplast-product-categories__section .mad-accordion__container');
    const categoriesImage = jQuery('.moreplast-product-categories__section .moreplast-categories-image');
    const categoriesImageHero = jQuery('.moreplast-hero-section .moreplast-categories-image');


    if (accordionContainer.length > 0 && categoriesImage.length > 0) {
      const accordionId = accordionContainer.attr('id');
      const accordionHash = accordionContainer.data('accordion-id');
      let accordion;

      if (accordionId) {
        accordion = window.Accordion.getInstanceById(accordionId);
      } else if (accordionHash) {
        accordion = window.Accordion.getInstanceByHash(accordionHash);
      }

      if (accordion) {
        accordion.setToggleCallback(() => {
          ScrollTrigger.refresh();
          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 300);
        });

        for (let index = 0; index < accordion.items.length; index++) {
          if (index + 1 > hotspotData.length) break;

          const accordionItem = accordion.items[index];
          hotspotData[index].clickCallback = () => {
            accordionItem.open();
          };
        }
        
        const hotspots = new window.Hotspots(categoriesImage, hotspotData);
        if (categoriesImageHero.length > 0) new window.Hotspots(categoriesImageHero, hotspotData);
      }
    }

    const categoriesImageColumn = categoriesImage.parent();
    const categoriesImageRow = categoriesImageColumn.parent();
    const getCategoriesImageColumnContainerHeight = () => categoriesImageColumn.outerHeight();

    // Check screen width and apply ScrollTrigger conditionally
    ScrollTrigger.matchMedia({
      // Desktop
      "(min-width: 992px)": function () {
        ScrollTrigger.create({
          trigger: categoriesImageRow,
          start: "top+=" + getCategoriesImageColumnContainerHeight() / 2 + " center",
          end: "bottom-=" + getCategoriesImageColumnContainerHeight() / 2 + " center",
          pin: categoriesImageColumn,
          pinSpacing: false
        });
      },
      // Tablet and Mobile
      "(max-width: 991px)": function () {
        // No ScrollTrigger for tablet and mobile
      }
    });

    jQuery(window).on('resize', function () {
      ScrollTrigger.refresh();
    });

    // Insert the arrow image and text, and apply GSAP opacity animation
    if (categoriesImageHero.length > 0) {
      const arrowSvgUrl = window.$madSettings.assetURL + '/img/arrow_top-right-to-bottom-left.svg';
      const arrowImg = jQuery('<img>').attr('src', arrowSvgUrl).attr('alt', 'Arrow').css('opacity', 0);
      const container = jQuery('<div class="moreplast-categories-image-arrow__container"></div>');
      const textElement = jQuery('<div class="moreplast-categories-image-text__container"><div class="moreplast-categories-image-text">Produktkategorien auswählen</div></div>');

      container.append(textElement);
      container.append(arrowImg);
      categoriesImageHero.append(container);

      // Fade in the arrow image and text using GSAP
      gsap.to([arrowImg, textElement], {
        opacity: 1,
        duration: 2,
        ease: "power2.inOut",
      });
    }
  }

  initializeHotspotsAndAccordion();
});
